import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ReplaySubject, takeUntil } from 'rxjs';
import { GoBackComponent } from 'shared/components/go-back/go-back.component';

@Component({
  selector: 'app-employer-deposit',
  templateUrl: './employer-deposit.component.html',
  styleUrl: './employer-deposit.component.scss',
  standalone: true,
  imports: [GoBackComponent, TranslateModule]
})
export class EmployerDepositComponent implements OnInit, OnDestroy {
  public selectedLanguage: string;
  private readonly _onDestroy$ = new ReplaySubject<void>(1);
  employerDeposit: any = {
    title: 'okeeyCash.employerDeposit.title',
    makeTheMost: 'okeeyCash.employerDeposit.makeTheMost',
    effectiveWay: 'okeeyCash.employerDeposit.effectiveWay',
    hardEarned: 'okeeyCash.employerDeposit.hardEarned',
    directDeposit: 'okeeyCash.employerDeposit.directDeposit',
    areSecure: 'okeeyCash.employerDeposit.areSecure',
    availabeForUse: 'okeeyCash.employerDeposit.availabeForUse',
    readyToUse: 'okeeyCash.employerDeposit.readyToUse',
    illustration: 'assets/img/my-okeey-cash/employer-deposit/illustration.svg',
    illustrationMobile: 'assets/img/my-okeey-cash/employer-deposit/illustration-mobile.svg',
    depositFormat: 'assets/img/my-okeey-cash/employer-deposit/deposit-format.svg',
    depositFormatSpanish: 'assets/img/my-okeey-cash/employer-deposit/deposit-format-spanish.svg',
    authorisationForm: 'okeeyCash.employerDeposit.authorisationForm'
  };
  constructor(private _translateService: TranslateService) {
    this.selectedLanguage = this._translateService.currentLang;
  }

  public ngOnInit(): void {
    this._setLangListener();
  }

  public ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  private _setLangListener(): void {
    this._translateService.onLangChange.pipe(takeUntil(this._onDestroy$)).subscribe(() => {
      this.selectedLanguage = this._translateService.currentLang;
    });
  }

  public openPdf(): void {
    const pdfUrl = 'assets/pdf/DDAform.pdf';
    window.open(pdfUrl, '_blank');
  }
}
